var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgradeRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7441 10.6767C17.064 7.90875 17.6561 4.05272 17.5921 2.88472C17.5921 2.75671 17.5281 2.64477 17.4481 2.54866C17.3681 2.46864 17.2561 2.40469 17.112 2.40469C15.944 2.34074 12.088 2.91675 9.33602 5.23672L8.69608 4.99676C7.57611 4.58079 6.31205 4.91674 5.54408 5.82879L3.76808 7.92465C3.51205 8.21259 3.64006 8.67665 4.00803 8.80468L5.91206 9.50871C5.49609 10.2127 5.20803 10.8047 5.01609 11.2208C4.85604 11.5568 4.93607 11.9568 5.20806 12.2288L7.76811 14.8047C8.02414 15.0607 8.42414 15.1407 8.77614 14.9807C9.19211 14.7887 9.78417 14.5007 10.4882 14.0847L11.1761 15.9887C11.3042 16.3567 11.7681 16.4688 12.0562 16.2287L14.1362 14.4527C15.0483 13.6847 15.3842 12.4207 14.9682 11.3007L14.7441 10.6767ZM13.5441 8.67672C12.936 9.28475 11.9441 9.28475 11.3201 8.67672C10.712 8.06869 10.712 7.07672 11.3201 6.45272C11.9281 5.84469 12.9201 5.84469 13.5441 6.45272C14.1521 7.07672 14.1521 8.06869 13.5441 8.67672Z",
    fill: "url(#paint0_linear_402_40929)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66399 15.4607L5.51199 16.5967C5.288 16.8207 5.288 17.2047 5.51199 17.4287C5.73598 17.6527 6.12002 17.6527 6.34402 17.4287L7.49602 16.2767C7.72001 16.0527 7.72001 15.6687 7.49602 15.4447C7.25595 15.2207 6.88799 15.2207 6.66399 15.4607V15.4607Z",
    fill: "url(#paint1_linear_402_40929)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00799 13.9887C5.784 13.7647 5.39996 13.7647 5.17596 13.9887L3.35208 15.8287C3.12808 16.0527 3.12808 16.4367 3.35208 16.6607C3.57607 16.8847 3.96011 16.8847 4.18411 16.6607L6.00799 14.8047C6.24806 14.5807 6.24806 14.2127 6.00799 13.9887V13.9887Z",
    fill: "url(#paint2_linear_402_40929)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55205 13.3487C4.77604 13.1247 4.77604 12.7407 4.55205 12.5167C4.32805 12.2927 3.94402 12.2927 3.72002 12.5167L2.56802 13.6687C2.34403 13.8927 2.34403 14.2767 2.56802 14.5007C2.79201 14.7247 3.17605 14.7247 3.40005 14.5007L4.55205 13.3487Z",
    fill: "url(#paint3_linear_402_40929)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_402_40929",
    x1: 17.5079,
    y1: 2.26228,
    x2: 5.11148,
    y2: 16.9617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED801F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_402_40929",
    x1: 7.64927,
    y1: 15.2557,
    x2: 5.5903,
    y2: 17.6981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED801F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_402_40929",
    x1: 6.16895,
    y1: 13.7911,
    x2: 3.49622,
    y2: 16.9545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED801F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_402_40929",
    x1: 4.7053,
    y1: 12.3258,
    x2: 2.6443,
    y2: 14.7685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED801F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeRocket);
export default __webpack_public_path__ + "static/media/upgrade-rocket.ea591eb9.svg";
export { ForwardRef as ReactComponent };